import { Controller } from "stimulus"
import GalleryModal from './../components/gallery-modal';

export default class extends Controller {
    static targets = [ 'item', 'caption' ];

    initialize() {
        this.galleryModal = GalleryModal.instance();
    }

    connect() {
        this.itemTargets.forEach((item, index) => {
            const caption = this.captionTargets[index] ? this.captionTargets[index].innerHTML : null; 
            const imgSrc = item.getAttribute('gallery-item');
            item.addEventListener('click', this.onClick.bind(this, index));
            this.galleryModal.createItem(index, imgSrc, caption);
        });
    }

    onClick(index) {
        this.galleryModal.open(index);
    }
}


// WEBPACK FOOTER //
// ./mysite/resources/js/controllers/gallery_controller.js